module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": "Manage Ads",
      "subtitle": ""
    }
  }, [_vm._c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#createModal"
    },
    on: {
      "click": _vm.openCreateModal
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "icon mdi mdi-plus"
  }), _vm._v("  Create Ad\n          ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('div', {
    staticClass: "filters"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group form-group-sm row"
  }, [_vm._c('label', {
    staticClass: "col-form-label col-xs-4 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStatus),
      expression: "selectedStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.selectedStatus = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.statusFilters), function(option) {
    return _vm._c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
  }))])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group form-group-sm row"
  }, [_vm._c('label', {
    staticClass: "col-form-label col-xs-4 control-label"
  }, [_vm._v("Company")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompany),
      expression: "selectedCompany"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.selectedCompany = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.companyFilters), function(option) {
    return _vm._c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
  }))])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group form-group-sm row"
  }, [_vm._c('label', {
    staticClass: "col-form-label col-xs-4 control-label"
  }, [_vm._v("Page")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPage),
      expression: "selectedPage"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.selectedPage = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.pageFilters), function(option) {
    return _vm._c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
  }))])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group form-group-sm"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search title..."
    },
    domProps: {
      "value": _vm._s(_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._c('DynamicTable', {
    attrs: {
      "data": _vm.filteredData,
      "fields": _vm.fields,
      "onClick": _vm.editRecord,
      "defaultSort": 'title'
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "settings-container"
  })], 1)], 1)])]), _vm._v(" "), _vm._c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "createModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_vm._c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_vm._c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.selectedAd) ? _vm._c('div', {
    staticClass: "modal-body"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtTitle"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.title),
      expression: "selectedAd.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtTitle"
    },
    domProps: {
      "value": _vm._s(_vm.selectedAd.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedAd.title = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtUrl"
    }
  }, [_vm._v("Link URL")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.url),
      expression: "selectedAd.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtUrl"
    },
    domProps: {
      "value": _vm._s(_vm.selectedAd.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedAd.url = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtCompany"
    }
  }, [_vm._v("New Company")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.company),
      expression: "selectedAd.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtCompany"
    },
    domProps: {
      "value": _vm._s(_vm.selectedAd.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedAd.company = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "ddlCompany"
    }
  }, [_vm._v("Or existing")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companySelect),
      expression: "companySelect"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ddlCompany"
    },
    on: {
      "change": [function($event) {
        _vm.companySelect = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.companyChanged]
    }
  }, _vm._l((_vm.companyFilters), function(option) {
    return _vm._c('option', [_vm._v("\n                      " + _vm._s(option) + "\n                    ")])
  }))])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtStart"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('datepicker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.start),
      expression: "selectedAd.start"
    }],
    attrs: {
      "format": "yyyy-MM-dd",
      "name": "startDate",
      "input-class": "form-control",
      "disabled-dates": _vm.disabledDates
    },
    domProps: {
      "value": (_vm.selectedAd.start)
    },
    on: {
      "input": function($event) {
        _vm.selectedAd.start = $event
      }
    }
  })], 1)])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtEnd"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('datepicker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.end),
      expression: "selectedAd.end"
    }],
    attrs: {
      "format": "yyyy-MM-dd",
      "name": "endDate",
      "input-class": "form-control",
      "disabled-dates": _vm.disabledDates
    },
    domProps: {
      "value": (_vm.selectedAd.end)
    },
    on: {
      "input": function($event) {
        _vm.selectedAd.end = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtPage"
    }
  }, [_vm._v("Display Page")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.displayPage),
      expression: "selectedAd.displayPage"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txtPage"
    },
    on: {
      "change": function($event) {
        _vm.selectedAd.displayPage = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.pageFilters), function(option) {
    return _vm._c('option', [_vm._v("\n                      " + _vm._s(option) + "\n                    ")])
  }))])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtSlot"
    }
  }, [_vm._v("Slot ID")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.slotID),
      expression: "selectedAd.slotID"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "id": "txtSlot"
    },
    domProps: {
      "value": _vm._s(_vm.selectedAd.slotID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedAd.slotID = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtStatus"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAd.status),
      expression: "selectedAd.status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "txtStatus"
    },
    on: {
      "change": function($event) {
        _vm.selectedAd.status = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.statusFilters), function(option) {
    return _vm._c('option', [_vm._v("\n                      " + _vm._s(option) + "\n                    ")])
  }))])])])]), _vm._v(" "), _vm._c('hr'), _vm._v(" "), _vm._c('p', [_vm._c('strong', [_vm._v("Suggested size (px):")]), _vm._v(" " + _vm._s(_vm.imageSize) + " - "), _vm._c('a', {
    attrs: {
      "href": "https://support.google.com/adsense/answer/6002621?hl=en",
      "target": "_blank"
    }
  }, [_vm._v("More info")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_vm._c('input', {
    attrs: {
      "type": "file",
      "name": "image"
    },
    on: {
      "change": _vm.imageAdded
    }
  }), _vm._v(" "), (_vm.imageLoading) ? _vm._c('div', {
    staticClass: "loading"
  }, [_vm._c('LoadingIndicator')], 1) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "image-preview"
  }, [_vm._c('img', {
    attrs: {
      "src": _vm.selectedAd.image
    }
  })])])])])]), _vm._v(" "), (_vm.errors.length > 0) ? _vm._c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n            Please correct the following errors:\n            "), _vm._c('ul', _vm._l((_vm.errors), function(e) {
    return _vm._c('li', [_vm._v(_vm._s(e))])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "modal-footer"
  }, [(_vm.selectedAd && _vm.selectedAd.id) ? _vm._c('button', {
    staticClass: "btn btn-danger pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteAd
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.imageLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "modal-header"
  }, [_vm._c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLabel"
    }
  }, [_vm._v("Ad details")])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-sm-3 col-form-label"
  }, [_vm._c('strong', [_vm._v("Select image")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68b8e797!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ad/admanager.vue
// module id = 673
// module chunks = 1